module.exports = "/static/assets/a9058f4b897d64506413873a1941c44b.svg";